import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=7b372b5a"
import script from "./CopyButton.vue?vue&type=script&lang=js"
export * from "./CopyButton.vue?vue&type=script&lang=js"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=7b372b5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports